import { AppointmentCancelReason } from './Appointment.ts';

export enum CancelAppointmentOptions {
    DOCTOR_CANCELLED = AppointmentCancelReason.DOCTOR_CANCELLED,
    PATIENT_CANCELLED = AppointmentCancelReason.PATIENT_CANCELLED,
    OTHER = AppointmentCancelReason.OTHER,
    NO_SHOW = 'NO_SHOW',
}

export const APPOINTMENT_CANCEL_OPTION_TRANSLATIONS: Record<CancelAppointmentOptions, string> = {
    [CancelAppointmentOptions.PATIENT_CANCELLED]: 'Patient hat abgesagt',
    [CancelAppointmentOptions.DOCTOR_CANCELLED]: 'Arzt hat abgesagt',
    [CancelAppointmentOptions.OTHER]: 'Sonstiger Grund',
    [CancelAppointmentOptions.NO_SHOW]: 'Patient nicht erschienen',
};
